import WpPost from "./WpPost";
export default WpPost;
